import type { ParseDiagnosticsTrace } from '@lib/docparser-diagnostics/types/parse-diagnostics-trace';
import type { DocumentProcessingWave } from '@lib/flows/types/document-processing-wave';
import { realtime, staticSchema } from '@lib/jobs/services/realtime';
import type { ProcessingStageId } from '@lib/upload-processing/types/processing-stage-id';

export type FlowDocumentProcessingDiagnostics = ParseDiagnosticsTrace;

export type FlowDocumentProcessingState =
  | 'processing'
  | 'processed'
  | 'failed'
  | 'needs_reupload';

export type FlowDocumentProcessingStatus = {
  flowId: string;
  collectionId: string;
  state: FlowDocumentProcessingState;
  message?: string;
  /**
   * True on a `processed` publish when the PDF landed but the parser produced no
   * schema. The upload is not blocked; the client warns that detection failed.
   */
  detectionFailed?: boolean;
  /** Checklist stage while `state` is `processing`. */
  stage?: ProcessingStageId;
  documentId?: string;
  documentUrl?: string;
  pagesProcessed?: number;
  totalPages?: number;
  fieldsDetected?: number;
  wave?: DocumentProcessingWave;
  firstWaveReady?: boolean;
  progressLabel?: string;
};

// Flow-scoped Realtime channel for async document processing state.
export const flowDocumentProcessingChannel = realtime.channel({
  name: ({ flowId }: { flowId: string }) =>
    `flow-document-processing:${flowId}`,
  topics: {
    status: {
      schema: staticSchema<FlowDocumentProcessingStatus>(),
    },
    diagnostics: {
      schema: staticSchema<FlowDocumentProcessingDiagnostics>(),
    },
  },
});
